import { useState, useEffect } from 'react';

import LoadingScreen from './../utils/LoadingScreen'

import '../../stylesheets/contact.css';

const Contact = (props) => {
    useEffect(() => {
        props.setOnPage(4)
    }, [props]) 

    const [mapLoaded, setMapLoaded] = useState(false)

    return (
        <>
            <div className="google-map-code">
                {
                    !mapLoaded &&
                        <LoadingScreen bgWhite={true} />
                }
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3770.0060394447705!2d72.83460861114641!3d19.10739098202912!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c9c676018b43%3A0x75f29a4205098f99!2sSVKM&#39;s%20Dwarkadas%20J.%20Sanghvi%20College%20of%20Engineering!5e0!3m2!1sen!2sin!4v1681728082008!5m2!1sen!2sin"
                    width="100%"
                    height={mapLoaded ? '450' : '0'}
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="DJSCE"
                    onLoad={() => setMapLoaded(true)}
                ></iframe>
            </div>
            <div className='contact'>
                <div className='hea'>
                    <p>Contact Us:</p>
                </div>
                <div className='phone'>
                    📞Riya Surya:&nbsp;<a href='tel:+91 96642 79479'>+91 96642 79479</a>
                </div>

                <div className='mailing'>
                    📧<a href='mailto:djsce.nsdc12@gmail.com'>djsce.nsdc12@gmail.com</a>
                </div>
            </div>
        </>
    );
}
export default Contact